import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import shallowEqual from 'fbjs/lib/shallowEqual';
import { ADDED_ELEMENT_ANIMATION_DURATION } from 'crazyEditor/core/constants/editorConstants';
import _ from 'lodash';
import isNode from 'detect-node';


if (!isNode) {
  require('gsap'); // eslint-disable-line no-unused-vars
  /* global Linear Bounce Power2 Power3 Power4 Back SlowMo Ease Elastic TimelineLite TweenLite */
}
export default class BaseElement extends Component {
  componentDidMount() {
    if (this.shouldAnimate()) {
      const {id} = this.props;

      const timeline = new TimelineLite();
      timeline.fromTo(`#${id}`, ADDED_ELEMENT_ANIMATION_DURATION * 0.6 / 1000,
        {
          y: '-50px',
          opacity: 0,
        },
        {
          y: '-0px',
          opacity: 1,
          ease: Power2.easeIn
        }
      ).to(`#${id}`, ADDED_ELEMENT_ANIMATION_DURATION * 0.20 / 1000,
        {
          y: '-10px',
          ease: Power2.easeOut
        }
      ).to(`#${id}`, ADDED_ELEMENT_ANIMATION_DURATION * 0.20 / 1000,
        {
          y: '0px',
          ease: Power2.easeIn
        }
      );
    }
  }

  shouldComponentUpdate(nextProps) {
    return !shallowEqual(this.props, nextProps);
  }

  getPosition() {
    const { layout } = this.props;
    return {
      position: 'absolute',
      top: layout.y,
      left: layout.x,
    };
  }

  getSize() {
    const { layout, definitionProps, publish, desktopId, autoHeightTextElement, data: {templateTagData}} = this.props;
    let richTextTemplateTagElement = false;
    if (templateTagData) {
      richTextTemplateTagElement = templateTagData.richText;
    }
    if (((autoHeightTextElement || !richTextTemplateTagElement || !publish) && definitionProps.autoHeight) || layout.height === 0) { // TODO simplify this if.
      const allowScroll = desktopId && publish;
      return {
        boxSizing: 'border-box',
        WebkitBoxSizing: 'border-box',
        minHeight: allowScroll ? layout.height : null,
        width: definitionProps.fullWidth ? '100%' : layout.width
      };
    }
    return {
      boxSizing: 'border-box',
      WebkitBoxSizing: 'border-box',
      height: layout.height,
      width: definitionProps.fullWidth ? '100%' : layout.width
    };
  }

  getCompProps() {
    const position = this.getPosition();
    const size = this.getSize();
    const {style, compProps, definitionProps, publish, data} = this.props;
    let {paddingBottom} = compProps;
    if (publish && definitionProps.autoHeight) { // allow element to expand on top of padding. to accommodate differences between browsers.
      paddingBottom = Math.min(paddingBottom || 0, 5);
    }
    const finalCompProps = {
      transitionProperty: 'border-radius, padding',
      transitionDuration: '50ms',
      transitionTimingFunction: 'ease-in-out',
      ...position,
      ...size,
      ..._.omit(compProps, [..._.keys(size), 'transition', 'WebkitTransition']),
      paddingBottom,
      ...style,
    };
    if (!_.isEmpty(data.href)) {
      finalCompProps.display = 'flex';
    }
    return finalCompProps;
  }

  shouldAnimate() {
    const {publish, added} = this.props;
    return (added && !publish);
  }

  render() {
    const { id, type, children, data, rootElementProps, className, data: {templateTagData, templateTag} } = this.props;
    let childrenToRender = children;

    if (!_.isEmpty(data.href)) {
      childrenToRender = <a target="_blank" href={data.href.replace('http://', 'https://')} style={{display: 'block', width: '100%'}}>{children}</a>;
    }
    return (
      <div
        id={id}
        className={className}
        style={this.getCompProps()}
        data-element-type={type}
        data-exclude-css-removal={templateTagData && templateTagData.richText ? true : undefined}
        data-cl-template-tag = {templateTag}
        {...rootElementProps}>
        {
          !_.isEmpty(childrenToRender) ?
            (<BaseElementInner shouldUpdate={!this.props.dragging}>
              {childrenToRender}
            </BaseElementInner>)
            : undefined
        }
      </div>
    );
  }
}

class BaseElementInner extends Component {
  shouldComponentUpdate(nextProps) {
    return nextProps.shouldUpdate;
  }

  render() {
    return (
      <Fragment>
        {this.props.children || null}
      </Fragment>
    );
  }
}
BaseElementInner.propTypes = {
  shouldUpdate: PropTypes.bool.isRequired,
};


BaseElement.propTypes = {
  id: PropTypes.string.isRequired,
  layout: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    width: PropTypes.oneOfType([PropTypes.number.isRequired, PropTypes.string.isRequired]),
    height: PropTypes.oneOfType([PropTypes.number.isRequired, PropTypes.string.isRequired])
  }),
  data: PropTypes.shape({
    compProps: PropTypes.object,
    href: PropTypes.string
  }),
  rootElementProps: PropTypes.object,
  style: PropTypes.object,
  compProps: PropTypes.object,
  added: PropTypes.bool,
  dragDelta: PropTypes.shape({
    deltaX: PropTypes.number.isRequired,
    deltaY: PropTypes.number.isRequired,
  }),
};

BaseElement.defaultProps = {
  data: {
    compProps: {}
  },
  style: {},
};